import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  forkJoin,
  Subject
} from 'rxjs';
import {
  CourseModel,
  LectureModel,
  TeacherModel,
} from 'src/app/models/backend.model';
import {
  BackendService
} from 'src/app/services/backend.service';
import {
  environment
} from 'src/environments/environment';
import {
  AuthService
} from 'src/app/auth/auth.service';
import {
  takeUntil
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { DisplayWidthService } from 'src/app/services/display-width.service';
import { CarouselAlignMode, CarouselComponent, CarouselConfig, CarouselWidthMode } from 'ng-carousel-cdk';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  backendUrl = environment.backendUrl;
  imageUrlArray = [this.backendUrl + 'image/home/1.webp', this.backendUrl + 'image/home/2.webp', this.backendUrl + 'image/home/3.webp'];
  teachers: TeacherModel[] = [];

  items: LectureModel;
  courses: CourseModel[] = [];

  height = '400px';
  divWidth: number;

  @ViewChild(CarouselComponent, { static: true }) lateCarouselRef?: CarouselComponent;
  @ViewChild(CarouselComponent, { static: true }) busnessCarouselRef?: CarouselComponent;
  @ViewChild(CarouselComponent, { static: true }) programmingCarouselRef?: CarouselComponent;
  @ViewChild(CarouselComponent, { static: true }) officeCarouselRef?: CarouselComponent;
  @ViewChild(CarouselComponent, { static: true }) marketingCarouselRef?: CarouselComponent;
  @ViewChild(CarouselComponent, { static: true }) packageCarouselRef?: CarouselComponent;


  lateUploadCatigoryConfig: CarouselConfig<CourseModel> = {
    widthMode: CarouselWidthMode.PX,
    slideWidth: 280,
    transitionDuration: 2500,
    alignMode: CarouselAlignMode.LEFT,
    shouldLoop: false,
    autoplayEnabled: false,
    items: this.courses,
    dragEnabled: true,
    shouldRecalculateOnResize: true,
    recalculateDebounce: 300,
    allowKeyboardNavigation: true,
  }

  packageCatigoryConfig: CarouselConfig<CourseModel> = {
    widthMode: CarouselWidthMode.PX,
    slideWidth: 280,
    transitionDuration: 2500,
    alignMode: CarouselAlignMode.LEFT,
    shouldLoop: false,
    autoplayEnabled: false,
    items: this.courses,
    dragEnabled: true,
    shouldRecalculateOnResize: true,
    recalculateDebounce: 300,
    allowKeyboardNavigation: true,
  }

  businessCatigoryConfig: CarouselConfig<CourseModel> = {
    widthMode: CarouselWidthMode.PX,
    slideWidth: 280,
    transitionDuration: 2500,
    alignMode: CarouselAlignMode.LEFT,
    shouldLoop: false,
    autoplayEnabled: false,
    items: this.courses,
    dragEnabled: true,
    shouldRecalculateOnResize: true,
    recalculateDebounce: 300,
    allowKeyboardNavigation: true,
  }

  programmingCatigoryConfig: CarouselConfig<CourseModel> = {
    widthMode: CarouselWidthMode.PX,
    slideWidth: 280,
    transitionDuration: 2500,
    alignMode: CarouselAlignMode.LEFT,
    shouldLoop: false,
    autoplayEnabled: false,
    items: this.courses,
    dragEnabled: true,
    shouldRecalculateOnResize: true,
    recalculateDebounce: 300,
    allowKeyboardNavigation: true,
  }

  officeCatigoryConfig: CarouselConfig<CourseModel> = {
    widthMode: CarouselWidthMode.PX,
    slideWidth: 280,
    transitionDuration: 2500,
    alignMode: CarouselAlignMode.LEFT,
    shouldLoop: false,
    autoplayEnabled: false,
    items: this.courses,
    dragEnabled: true,
    shouldRecalculateOnResize: true,
    recalculateDebounce: 300,
    allowKeyboardNavigation: true,
  }

  marketingCatigoryConfig: CarouselConfig<CourseModel> = {
    widthMode: CarouselWidthMode.PX,
    slideWidth: 280,
    transitionDuration: 2500,
    alignMode: CarouselAlignMode.LEFT,
    shouldLoop: false,
    autoplayEnabled: false,
    items: this.courses,
    dragEnabled: true,
    shouldRecalculateOnResize: true,
    recalculateDebounce: 300,
    allowKeyboardNavigation: true,
  }

  photoCatigoryConfig: CarouselConfig<CourseModel> = {
    widthMode: CarouselWidthMode.PX,
    slideWidth: 280,
    transitionDuration: 2500,
    alignMode: CarouselAlignMode.LEFT,
    shouldLoop: false,
    autoplayEnabled: false,
    items: this.courses,
    dragEnabled: true,
    shouldRecalculateOnResize: true,
    recalculateDebounce: 300,
    allowKeyboardNavigation: true,
  }

  teacherConfig: CarouselConfig<TeacherModel> = {
    widthMode: CarouselWidthMode.PX,
    slideWidth: 280,
    transitionDuration: 2500,
    alignMode: CarouselAlignMode.LEFT,
    shouldLoop: true,
    autoplayEnabled: true,
    items: this.teachers,
    dragEnabled: true,
    shouldRecalculateOnResize: true,
    recalculateDebounce: 300,
    allowKeyboardNavigation: true,
  };


  private readonly destroy$ = new Subject<void>();
  isLoading = false;
  isProgressLoading = false;
  userIsAuthenticated = false;

  categoryCourses: {
    category: string,
    courses: CourseModel[]
  }[] = [];

  constructor(
    private readonly backendService: BackendService,
    private readonly authService: AuthService,
    private readonly displayWidthService: DisplayWidthService,
    private readonly router: Router,
  ) {
    this.isLoading = true;
    this.isProgressLoading = true;
    forkJoin([this.backendService.getHome(), this.backendService.listTeachers()]).subscribe(res => {
      this.isLoading = false;
      this.categoryCourses = res[0].result;
      this.teacherConfig.items = res[1].result;

      this.lateUploadCatigoryConfig.items = this.categoryCourses[0].courses;
      this.businessCatigoryConfig.items = this.categoryCourses[1].courses;
      this.programmingCatigoryConfig.items = this.categoryCourses[2].courses;
      this.officeCatigoryConfig.items = this.categoryCourses[3].courses;
      this.marketingCatigoryConfig.items = this.categoryCourses[4].courses;
      this.packageCatigoryConfig.items = this.categoryCourses[5].courses;

    });
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authService.getAuthStatusListener().pipe(takeUntil(this.destroy$)).subscribe(
      isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated
        if (isAuthenticated) {
          this.backendService.getProgressItem().then(res => {
            this.isProgressLoading = false;
            this.items = res.result
          }).catch(e => {
            this.isProgressLoading = false;
          })
        }
      }
    );
  }

  ngOnInit() {
    this.displayWidthService.innerWidth$.subscribe(x => {
      this.divWidth = x
      if (x > 960) {
        this.height = '400px';
      } else {
        this.height = '200px';
      }
    })
  }


  onClick(item) {

    if (item?.time && item.item.kind === 'lecture') {
      this.router.navigate([`/course/${item.item.course.name}/lecture/${item.item.name}`], { queryParams: { t: item.time } })
    } else {
      this.router.navigate([`/course/${item.item.course.name}/lecture/${item.item.name}`])

    }
  }


}
